<template>
  <div class="login">
    <h1>登陆后 你可以直接获取</h1>
    <p class="funcs">
      <span
        v-for="func in funcs"
        :key="func.name"
        :style="`color:${func.color}`"
      >
        {{ func.name }}
      </span>
    </p>
    <p class="desc">
      告别OA 、邮件、Space、柔宇学院等公司所有系统的重复登录
    </p>
    <a
      href="http://we.royole.com"
      target="_blank"
      @click="login"
    >
      立即登陆,点亮灯塔
    </a>
  </div>
</template>

<script>
import { setToken } from '@/utils/auth';

export default {
  data() {
    return {
      funcs: [
        {
          name: 'OA代办事项',
          color: '#f05050',
        },
        {
          name: '未读邮件',
          color: '#1e3ca8',
        },
        {
          name: '会议安排',
          color: '#ffc800',
        },
        {
          name: 'OA流程最新进度',
          color: '#f69696',
        },
        {
          name: '更多便捷功能',
          color: '#9da5c2',
        },
      ],
    };
  },
  methods: {
    login() {
      this.$store.dispatch('GetInfo', 'xxxxxxxx').then(() => {
        setToken('xxxx');
        this.$router.push({ path: '/' });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 936px;
  height: 291px;
  overflow: hidden;;
  background-color: #fff;
  h1{
    padding-top: 60px;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 19px;
    color: #1e3ca8;
  }
  .funcs {
    padding-top: 40px;
    span{
      display: inline-block;
      margin-right: 40px;
      font-size: 14px;
    }
  }
  .desc {
    padding-top: 24px;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0px;
    color: #788acb;
  }
  a {
    display: block;
    margin: 30px auto 0 auto;
    width: 180px;
    height: 34px;
    cursor: pointer;
    background-color: #1e3ca8;
    box-shadow: 0 5px 15px 0
    rgba(0, 55, 255, 0.3),
    0 2px 4px 0
    rgba(30, 60, 168, 0.2);
    border-radius: 17px;
    color: #fff;
    font-size: 14px;
    line-height:34px;
  }
  button:hover {
    opacity: .9;
  }

}
</style>
